import React, { useState } from "react";
import ImageGallery from "./ImageGallery";
import gallaryCoverMobile from "../../Assets/Hompage/Banner/Home page-05.jpg";

import UseTitle from "../Hooks/UseTitle";
const Gallery = () => {
  UseTitle("Gallery");

  return (
    <div className="">
      <div className="pt-16 md:pt-0 hidden md:block">
        <img
          src="https://i.ibb.co/6gBF7Pb/gallery-cover.jpg"
          alt="Gallery"
          className=" w-full"
        />
      </div>
      <div className="pt-16 md:pt-0 md:hidden block">
        <img src={gallaryCoverMobile} alt="Gallery" className=" w-full" />
      </div>
      <div className="max-w-screen-xl mx-auto pb-10 md:px-0 px-8">
        <div className="mt-20">
          <div className="flex ">
            <div className="nahid-title-designer">
              <h1 className="text-[40px] font-bold tracking-wide ">Gallery</h1>
              <p className="text-[18px] mt-10 text-justify">
                Let's explore our peace of heaven virtually
              </p>
            </div>
          </div>
          <div className="py-20">
            <ImageGallery />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
